import { Box, Typography } from "@mui/material";
import { NavigationButton } from "@components";

type CompletedSelectionMessageProps = {
  onRestart: () => void;
};

export const CompletedSelectionMessage = ({
  onRestart,
}: CompletedSelectionMessageProps) => (
  <Box
    sx={{
      padding: 3.5,
      border: "1px dashed var(--border)",
      borderRadius: 1.5,
      textAlign: "center",
    }}
  >
    <Typography>
      You have completed all the activities for this selection.
    </Typography>
    <NavigationButton
      variant="outlined"
      sx={{ marginTop: 2.5 }}
      type="button"
      onClick={onRestart}
    >
      Change preferences
    </NavigationButton>
  </Box>
);
